import React, { useEffect, useState } from 'react'

// redux
import { connect } from 'react-redux'

// includes
import EditMode from './includes/EditMode'
import DomainListing from './includes/DomainListing'
import DomainSettings from './includes/DomainSettings'

// react toastify
import { toast } from 'react-toastify';

// API
import { deleteDomainApi } from 'utlis/Apis/Notifications_API';

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,

    DOMAIN_DELETED_SUCCESSFULLY
} from 'utlis/AppMessages/AppMessages'

// skeletyon
import SkeletonLoading from './Domain__loadingSkeleton'

function DomainDetails(props) {
    // props
    const {
        loading,

        notificationsData,
        setNotificationsData,

        commonToken
    } = props

    // states
    const [editModeVisibility, setEditModeVisibility] = useState(false)
    const [DNSsettingsVisibility, setDNSsettingsVisibility] = useState(false)
    const [sectionLoading, setSectionLoading] = useState(false)

    // function to delete domain 
    const deleteDomain = () => {
        // btn loading
        setSectionLoading(true)

        // network request
        deleteDomainApi(commonToken).then(res => {
            // btn loading
            setSectionLoading(false)

            const resData = res.data

            console.log("resData ", resData);

            // if request succesfull
            if (resData && resData.success) {
                setNotificationsData(resData.data) // setting notifications data

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the success message
                toast.success(DOMAIN_DELETED_SUCCESSFULLY, {
                    autoClose: 2500
                })
            }

            // if request is not succesfull
            if (resData && resData.error) {
                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(resData?.message ?? UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} deleteDomainApi `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    // btn loading
                    setSectionLoading(false)
                }
            })
        })
    }

    // to delete domain info
    const handleDeleteDomain = (ev) => {
        ev.preventDefault()
        const confirmation = window.confirm("Are you sure you want to delete the domain name?")
        if (confirmation) { // if user confirms
            deleteDomain() // callign delete domain
        }
    }

    return (
        <React.Fragment>
            {
                loading ? (
                    <div className="page-border-box2 mb-3 mb-md-4 domain-info">
                        <div className="pbb2-inner">
                            <SkeletonLoading />
                        </div>
                    </div>
                ) : (
                    <React.Fragment>
                        {
                            /* page border box 2 */
                            editModeVisibility ? ( // if edim mode is true
                                <EditMode
                                    notificationsData={notificationsData}
                                    setNotificationsData={setNotificationsData}

                                    setEditModeVisibility={setEditModeVisibility}
                                    setDNSsettingsVisibility={setDNSsettingsVisibility}
                                />
                            ) : (
                                <React.Fragment>
                                    {
                                        notificationsData?.postmark_domain ? ( // if domain details exists then show the domain listing page
                                            <React.Fragment>
                                                {
                                                    DNSsettingsVisibility ? ( // is DNS settings view is vbisible
                                                        <DomainSettings
                                                            setDNSsettingsVisibility={setDNSsettingsVisibility}

                                                            notificationsData={notificationsData}
                                                            setNotificationsData={setNotificationsData}
                                                        />
                                                    ) : (
                                                        <DomainListing
                                                            sectionLoading={sectionLoading}

                                                            setDNSsettingsVisibility={setDNSsettingsVisibility}

                                                            notificationsData={notificationsData}
                                                            setNotificationsData={setNotificationsData}

                                                            handleDeleteDomain={handleDeleteDomain}
                                                        />
                                                    )
                                                }
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <div className="page-border-box2 mb-3 mb-md-4 domain-info">
                                                    <div className="pbb2-inner d-flex">
                                                        {/* text-sec */}
                                                        <div className="text-sec media-body pe-3">
                                                            <div className="app-header-wrapper heading-sm mb-2">
                                                                <p className="app-heading text-capitalize mb-2">Send from any email address on a domain</p>
                                                                <p className="app-desc st-fs-14">
                                                                    A more technical approach which requires that you verify your domain by adding a DKIM DNS record
                                                                </p>
                                                            </div>
                                                        </div>

                                                        {/* btn sec */}
                                                        <div className="btn-sec">
                                                            <button className="st-btn st-btn-sm" onClick={ev => {
                                                                ev.preventDefault()

                                                                setEditModeVisibility(!editModeVisibility)
                                                            }}>
                                                                Add Domain
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}

const getDataFromStore = state => {
    return {
        commonToken: state.auth.commonToken
    };
}

const dispatchActionsToProps = dispatch => {
    return {
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(DomainDetails)